import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import Head from 'next/head';
import DashboardMetrics from '@/featured/dashboard/metrics';
import { useDashboardSummary } from '@/api/queries/notification';

export default function Dashboard() {
  const { data, isError, isLoading } = useDashboardSummary();

  if (isError) {
    return <div>Error loading dashboard data.</div>;
  }

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!data) {
    return <div>No dashboard data available.</div>;
  }

  return (
    <>
      <Head>
        <title>Dashboard · Missi</title>
      </Head>
      <DashboardMetrics data={data} />
    </>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/')({
  component: Dashboard,
});
